<div class="attachments">
  <table class="attachments_table">
    <tr class="attachments_table-header">
      <th class="attachments_table-header-name">{{ 'Name' | transloco }}</th>
      <th>{{ 'UpdatedAt' | transloco }}</th>
    </tr>

    @for (attachment of filteredAttachments; track attachment.id) {
      <tr
        class="attachments_table-row"
        [attr.data-testid]="'node-detail-popover-attachments_row-' + attachment.id"
        [class.attachments_table-row--disabled]="!isOnline()"
        [ttTooltip]="'Offline.DisabledAttachmentDownloads'"
        [ttTooltipDisabled]="isOnline()"
        (click)="handleRowClick(attachment)">
        <td class="attachments_name">
          <div class="attachments_icon">
            <mat-icon [icon]="attachment.fileType" [iconSize]="14" />
          </div>
          <span class="attachments_title" data-testid="node-detail-popover-attachments_title">{{ attachment.title }}</span>
        </td>

        <td
          class="attachments_date"
          [ttTooltip]="attachment.updatedAtTimestamp | addZToUTC | translocoDate: { hour: '2-digit', minute: '2-digit', hour12: false }">
          {{ attachment.updatedAtTimestamp | addZToUTC | translocoDate }}
        </td>
      </tr>
    }
    @for (attachment of localAttachments; track attachment.id) {
      <tr
        class="attachments_table-row"
        [attr.data-testid]="'node-detail-popover-attachments_row-' + attachment.id"
        [class.attachments_table-row--disabled]="!isOnline()"
        [ttTooltip]="'Offline.DisabledAttachmentDownloads'"
        [ttTooltipDisabled]="isOnline()"
        (click)="handleRowClick(attachment)">
        <td class="attachments_name">
          <div class="attachments_icon">
            <mat-icon [icon]="attachment.fileType" [iconSize]="14" />
          </div>
          <span class="attachments_title" data-testid="node-detail-popover-attachments_title">{{ attachment.title }}</span>
        </td>
        <td
          class="attachments_date"
          [ttTooltip]="attachment.updatedAtTimestamp | addZToUTC | translocoDate: { hour: '2-digit', minute: '2-digit', hour12: false }">
          {{ attachment.updatedAtTimestamp | addZToUTC | translocoDate }}
        </td>
      </tr>
    }
  </table>
</div>
